/**
 * The support reference attached to every logged error, and shown on the crash screen.
 *
 * Deliberately dependency-free so the UI can use it without pulling in the APM agent or runtime
 * config; `apm.js` pushes its state in here at startup instead.
 */

/** Short enough to read over the phone, unique enough within a support window. */
export const makeRef = () => Math.random().toString(36).slice(2, 10);

let apmActive = false;

export const setApmActive = value => {
    apmActive = Boolean(value);
};

/** When false we must not show a reference — support would have nothing to look it up against. */
export const isApmActive = () => apmActive;
